// extracted by mini-css-extract-plugin
export var grid = "_16-0";
export var span1 = "_16-2";
export var span10 = "_16-b";
export var span10L = "_16-z";
export var span10M = "_16-n";
export var span10Xl = "_16-1b";
export var span11 = "_16-c";
export var span11L = "_16-10";
export var span11M = "_16-o";
export var span11Xl = "_16-1c";
export var span12 = "_16-d";
export var span12L = "_16-11";
export var span12M = "_16-p";
export var span12Xl = "_16-1d";
export var span1L = "_16-q";
export var span1M = "_16-e";
export var span1Xl = "_16-12";
export var span2 = "_16-3";
export var span2L = "_16-r";
export var span2M = "_16-f";
export var span2Xl = "_16-13";
export var span3 = "_16-4";
export var span3L = "_16-s";
export var span3M = "_16-g";
export var span3Xl = "_16-14";
export var span4 = "_16-5";
export var span4L = "_16-t";
export var span4M = "_16-h";
export var span4Xl = "_16-15";
export var span5 = "_16-6";
export var span5L = "_16-u";
export var span5M = "_16-i";
export var span5Xl = "_16-16";
export var span6 = "_16-7";
export var span6L = "_16-v";
export var span6M = "_16-j";
export var span6Xl = "_16-17";
export var span7 = "_16-8";
export var span7L = "_16-w";
export var span7M = "_16-k";
export var span7Xl = "_16-18";
export var span8 = "_16-9";
export var span8L = "_16-x";
export var span8M = "_16-l";
export var span8Xl = "_16-19";
export var span9 = "_16-a";
export var span9L = "_16-y";
export var span9M = "_16-m";
export var span9Xl = "_16-1a";
export var stretch = "_16-1";